// src/components/layout/mobile/MobileListPlaceholders.tsx
// Shared loading skeleton and empty state for mobile card lists.

interface MobileListSkeletonProps {
  count?: number;
  itemHeight?: string;
}

export function MobileListSkeleton({ count = 6, itemHeight = 'h-[72px]' }: MobileListSkeletonProps) {
  return (
    <div className="space-y-1 p-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className={`${itemHeight} rounded-lg bg-muted/50 animate-pulse`} />
      ))}
    </div>
  );
}

interface MobileEmptyStateProps {
  message: string;
}

export function MobileEmptyState({ message }: MobileEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <p className="text-muted-foreground text-sm">{message}</p>
    </div>
  );
}
